var map = {
	"./arrow-bottom.svg": "./app/general/svg/arrow-bottom.svg",
	"./arrow-left.svg": "./app/general/svg/arrow-left.svg",
	"./arrow-right.svg": "./app/general/svg/arrow-right.svg",
	"./arrow-top.svg": "./app/general/svg/arrow-top.svg",
	"./auction.svg": "./app/general/svg/auction.svg",
	"./bid.svg": "./app/general/svg/bid.svg",
	"./close.svg": "./app/general/svg/close.svg",
	"./cross.svg": "./app/general/svg/cross.svg",
	"./download.svg": "./app/general/svg/download.svg",
	"./facebook.svg": "./app/general/svg/facebook.svg",
	"./googlecalendar.svg": "./app/general/svg/googlecalendar.svg",
	"./grid.svg": "./app/general/svg/grid.svg",
	"./icalendar.svg": "./app/general/svg/icalendar.svg",
	"./info.svg": "./app/general/svg/info.svg",
	"./list.svg": "./app/general/svg/list.svg",
	"./logo.svg": "./app/general/svg/logo.svg",
	"./menu.svg": "./app/general/svg/menu.svg",
	"./minus-thin.svg": "./app/general/svg/minus-thin.svg",
	"./minus.svg": "./app/general/svg/minus.svg",
	"./outlook.svg": "./app/general/svg/outlook.svg",
	"./phone.svg": "./app/general/svg/phone.svg",
	"./photo.svg": "./app/general/svg/photo.svg",
	"./plus-thin.svg": "./app/general/svg/plus-thin.svg",
	"./plus.svg": "./app/general/svg/plus.svg",
	"./print.svg": "./app/general/svg/print.svg",
	"./refine.svg": "./app/general/svg/refine.svg",
	"./search.svg": "./app/general/svg/search.svg",
	"./share.svg": "./app/general/svg/share.svg",
	"./star.svg": "./app/general/svg/star.svg",
	"./tick.svg": "./app/general/svg/tick.svg",
	"./twitter.svg": "./app/general/svg/twitter.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/general/svg recursive ^\\.\\/.*\\.svg";


//////////////////
// WEBPACK FOOTER
// ./app/general/svg ^\.\/.*\.svg
// module id = ./app/general/svg recursive ^\.\/.*\.svg
// module chunks = app